import { render, staticRenderFns } from "./person-progress-notes.vue?vue&type=template&id=3e2ef70b"
import script from "./person-progress-notes.vue?vue&type=script&lang=js"
export * from "./person-progress-notes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports